module.exports = __webpack_public_path__ + "static/media/Juk Translated by J_Lee_77777.14bea0cd.md";